<template>
    <div
    class="circle"
    :class="{
        'selected': selectedClass,
        'small-circle': smallCircleClass,
        'smaller-circle': smallerCircleClass
    }"/>
</template>

<script setup>
/* Vue */
import { ref, computed, watch } from 'vue'

/* Props
@listLength {Number} - number of itens in slider
@circleIndex {Number} - circleIndex
@selectedIndex {Number} - index of selected item
*/
const props = defineProps({
    listLength: Number,
    circleIndex: Number,
	selectedIndex: Number
})

const selectedClass = ref(false)
const movingBack = ref(false)

const smallCircleClass = computed(() => {
    if (props.listLength <= 6) return false

    if ((props.selectedIndex === 3 && props.circleIndex === 0) || (props.circleIndex === 5 && props.listLength - 4 === props.selectedIndex)) {
        return true
    }

    return ((props.circleIndex === 1 && props.selectedIndex > 3) || (props.circleIndex === 4 && (Math.abs(props.selectedIndex - props.listLength) > 4)))
})

const smallerCircleClass = computed(() => {
    if (props.listLength <= 6) return false

    return ((props.circleIndex === 0 && props.selectedIndex > 2) || (props.circleIndex === 5 && (Math.abs(props.selectedIndex - props.listLength) > 4)))
})

const validateSelectedClass = () => {
    selectedClass.value = false

    if (props.listLength <= 6) {
        selectedClass.value = props.circleIndex === props.selectedIndex
        return
    }

    setTimeout(() => {
        if (props.selectedIndex < 3) {
            selectedClass.value = props.circleIndex === props.selectedIndex
        } else if (props.selectedIndex >= 3 && props.selectedIndex < (props.listLength - 3)) {
            selectedClass.value = movingBack.value ? props.circleIndex === 2 : props.circleIndex === 3
        } else {
            selectedClass.value = props.circleIndex === 6 - Math.abs(props.selectedIndex - props.listLength)
        }
    }, 200)
}

watch(() => props.selectedIndex, (newVal, oldVal) => {
    movingBack.value = newVal < oldVal
    validateSelectedClass()
})

validateSelectedClass()
</script>

<style lang="scss" scoped>
.circle {
    width: 6px;
    height: 6px;
    flex-shrink: 0;

    border-radius: 50%;
    background-color: var(--secondary-dark-4);
    transition: all .3s linear;
    opacity: 0.2;

    &.small-circle {
        width: 4px;
        height: 4px;
    }

    &.smaller-circle {
        width: 2px;
        height: 2px;
    }

    &.selected {
        width: 12px;
        height: 12px;

        background-color: var(--primary);
        opacity: 1;
    }
}
</style>
